import { Alert, Stack, Text } from "@mantine/core";

export default function LegacyExtractionWarnings({
  warnings,
}: {
  warnings: string[];
}) {
  if (!warnings.length) return null;
  return (
    <Alert
      color="orange"
      title="Review extraction warnings"
      role="alert"
      variant="light"
      styles={{ body: { minWidth: 0 }, message: { minWidth: 0 } }}
    >
      <Stack gap="xs" miw={0}>
        {warnings.map((warning, index) => (
          <Text size="sm" key={index} style={{ overflowWrap: "anywhere" }}>
            {warning}
          </Text>
        ))}
      </Stack>
    </Alert>
  );
}
